import React from "react";
import "../less/main.less";
import clearBR from "../../../../helpers/utils/clearBR";
import Preloader from "MWComponents/dest/components/Preloader";


export default function template() {
  const { isMobile, page, widget } = this.props,
    items = widget.data ? this.filterSlidesByEnvironment(widget.data) : [];
  const questions = items.sort((a, b) => a.order - b.order).map((item, index) => {
      const question = isMobile ? clearBR(item.title_ua) : item.title_ua;
      return (
        <div key={index} className="question">
          <a href={`#${index}`} dangerouslySetInnerHTML={{ __html: question }}></a>
        </div>
      );
    }),
    answers = items.sort((a, b) => a.order - b.order).map((item, index) => {
      const question = item.title_ua;
      const answer = isMobile ? clearBR(item.desc_ua) : item.desc_ua;
      return (
        <div key={item.id}>
          <div className={`anchor_${item.id}`} id={`${index}`}></div>
          <div key={index} className="answer">
            <div className="answer-title" dangerouslySetInnerHTML={{ __html: question }}></div>
            <div className="answer-text" dangerouslySetInnerHTML={{ __html: answer }}></div>
          </div>
        </div>
      );
    });

  return (
    items.length ?
      (
        <div className={`${page}-wrapper question-block-admin`}>
          <div className="left-side">
            {questions}
          </div>
          <div className="right-side">
            {answers}
          </div>
        </div>
      ) : <Preloader></Preloader>

  );
}
